import React from "react";

import { Box, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Avatar from "@rui/Avatar";
import { Row } from "@rui/Stack";

import { AutocompleteOption } from "./AddTeamMembersModal";

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFF",
  margin: theme.spacing(1),
  padding: theme.spacing(1),
  borderRadius: theme.corners.base,
  "&:first-of-type": { marginTop: 0 },
  "&:last-child": { marginBottom: 0 },
}));

const DISABLED_SX = {
  bgcolor: "background.default",
  pointerEvents: "none",
};

const AVATAR_SX = {
  height: "28px",
  width: "28px",
  fontSize: "0.75rem",
};

const TeamMemberAutocompleteOption = ({
  option,
  onTeam,
  ...autocompleteProps
}: {
  option: AutocompleteOption;
  onTeam: boolean;
}) => {
  const isInvite = option.type === "invite";
  const optionDisabled = onTeam || isInvite;

  const getDisabledText = () => {
    switch (true) {
      case onTeam:
        return "Already in this team";
      case isInvite:
        return "Pending Workspace Invite";
      default:
        return "";
    }
  };

  return (
    <Container
      {...autocompleteProps}
      sx={optionDisabled ? DISABLED_SX : undefined}
    >
      <Row variant="apart" flex={1} height="28px" overflow="hidden" spacing={1}>
        <Row variant="left" overflow="hidden" flexShrink={1} spacing={1}>
          <Avatar name={option.fullName ?? option.email} sx={AVATAR_SX} />
          <Typography
            variant="bodyPrimaryReg"
            noWrap
            color={optionDisabled ? "shades.neutral.500" : "shades.neutral.800"}
          >
            {option.fullName ?? option.email}
          </Typography>
        </Row>
        {optionDisabled && (
          <Typography
            variant="bodySecondaryReg"
            color="shades.neutral.500"
            whiteSpace="nowrap"
          >
            {getDisabledText()}
          </Typography>
        )}
      </Row>
    </Container>
  );
};

export default TeamMemberAutocompleteOption;
